import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app.routing.module';
import { HelpComponent } from './pages/help/help.component';
import { HomeComponent } from './pages/home/home.component';
import { CommandsComponent } from './pages/help/commands/commands.component';
import { GettingStartedComponent } from './pages/getting-started/getting-started.component';
import * as env from '../environments/environment';
import { AboutComponent } from './pages/about/about.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { SupportComponent } from './pages/support/support.component';
import { MarkdownComponent } from './pages/help/commands/markdown/markdown.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { GuildCardsComponent } from './pages/guild-selection/guild-cards/guild-cards.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FindEventPipe } from './pipes/find-event.pipe';
import { PremiumUnifiedComponent } from './pages/premium-unified/premium-unified.component';
import { StatisticsComponent } from './pages/home/statistics/statistics.component';
// import { NgxObserveModule } from 'ngx-observe';
import { NgxPayPalModule } from 'ngx-paypal';
import { GuildSelectionComponent } from './pages/guild-selection/guild-selection.component';
// import { DarkModeComponent } from './dark-mode/dark-mode.component';
import { GuildDashboardComponent } from './pages/guild-dashboard/guild-dashboard.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTreeModule } from '@angular/material/tree';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverviewCardComponent } from './pages/guild-dashboard/overview-card/overview-card.component';
import { ServerCardComponent } from './pages/guild-dashboard/server-card/server-card.component';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ChannelCardComponent } from './pages/guild-dashboard/channel-card/channel-card.component';
import { UserCardComponent } from './pages/guild-dashboard/user-card/user-card.component';
import { NgxColorsModule } from 'ngx-colors';
import { DurationPipe } from './pipes/duration.pipe';
import { SignupTemplateCardComponent } from './pages/guild-dashboard/signupTemplate-card/signupTemplate-card.component';
import { EmbedBuilderComponent } from './components/embed-builder/embed-builder.component';
import { EmbedService } from './services/embed.service';
import { EmbedPreviewComponent } from './components/embed-preview/embed-preview.component';
import { SignupTemplateBuilderComponent } from './components/signup-template-builder/signup-template-builder.component';
import { MarkdownModule } from 'ngx-markdown';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { EmojiPickerButtonComponent } from './components/emoji-picker-button/emoji-picker-button.component';
import { DisableLinkDirective } from './directives/disable-link.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EventCardComponent } from './pages/guild-dashboard/event-card/event-card.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SignupGroupCardComponent } from './pages/guild-dashboard/signupGroup-card/signupGroup-card.component';
import { SignupGroupBuilderComponent } from './components/signup-group-builder/signup-group-builder.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { RepeatingEventCardComponent } from './pages/guild-dashboard/repeating-event-card/repeating-event-card.component';
import { BotOwnerPreviewInterceptor } from './services/bot-owner-preview.interceptor';
import { TemplatesCatalogueComponent } from './pages/templates-catalogue/templates-catalogue.component';
import { TemplateDetailComponent } from './pages/template-detail/template-detail.component';
import { TemplatesReviewComponent } from './pages/templates-review/templates-review.component';
import { MyTemplatesComponent } from './pages/my-templates/my-templates.component';
import { ShareTemplateDialogComponent } from './components/share-template-dialog/share-template-dialog.component';
import { EditCatalogueTemplateDialogComponent } from './components/edit-catalogue-template-dialog/edit-catalogue-template-dialog.component';
import { AuthorResubmitCatalogueDialogComponent } from './components/author-resubmit-catalogue-dialog/author-resubmit-catalogue-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    HelpComponent,
    HomeComponent,
    CommandsComponent,
    GettingStartedComponent,
    AboutComponent,
    TermsComponent,
    PrivacyComponent,
    SupportComponent,
    MarkdownComponent,
    GuildCardsComponent,
    FindEventPipe,
    PremiumUnifiedComponent,
    StatisticsComponent,
    GuildSelectionComponent,
    // DarkModeComponent,
    GuildDashboardComponent,
    OverviewCardComponent,
    ServerCardComponent,
    ChannelCardComponent,
    SignupTemplateCardComponent,
    SignupGroupCardComponent,
    EventCardComponent,
    UserCardComponent,
    DurationPipe,
    EmbedBuilderComponent,
    EmbedPreviewComponent,
    SignupTemplateBuilderComponent,
    EmojiPickerButtonComponent,
    DisableLinkDirective,
    SignupGroupBuilderComponent,
    RepeatingEventCardComponent,
    TemplatesCatalogueComponent,
    TemplateDetailComponent,
    TemplatesReviewComponent,
    MyTemplatesComponent,
    ShareTemplateDialogComponent,
    EditCatalogueTemplateDialogComponent,
    AuthorResubmitCatalogueDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MarkdownModule.forRoot(),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [env.environment.baseUrlDiscord, 'api'],
        sendAccessToken: true,
      },
    }),
    ToastrModule.forRoot(),
    FontAwesomeModule,
    // NgxObserveModule,
    NgxPayPalModule,
    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatTreeModule,
    MatExpansionModule,
    MatListModule,
    MatCardModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTableModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatTabsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    NgxColorsModule,
    PickerModule,
    DragDropModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatMomentModule,
    NgxMatSelectSearchModule,
  ],
  providers: [
    EmbedService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BotOwnerPreviewInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [EmojiPickerButtonComponent, DisableLinkDirective],
})
export class AppModule {}
